export const STYLE_KEY_MAP: Readonly<Record<string, string>> = {
  font_size: 'fontSize',
  font_size_pt: 'fontSizePt',
  font_weight: 'fontWeight',
  font_weight_value: 'fontWeightValue',
  text_align: 'textAlign',
  text_color: 'textColor',
  background_color: 'backgroundColor',
  padding_y: 'paddingY',
  border_top: 'borderTop',
  border_bottom: 'borderBottom',
  preview_height: 'previewHeight',
  font_family: 'fontFamily',
  border_color: 'borderColor'
};

/**
 * Remap snake_case style keys into camelCase using {@link STYLE_KEY_MAP}.
 *
 * - Pure function: never mutates the input object.
 * - Passes through unknown keys unchanged.
 * - Returns `{}` when `input` is `undefined`.
 */
export function normalizeStyleKeys(input: Record<string, unknown> | undefined): Record<string, unknown> {
  if (input === undefined) return {};

  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(input)) {
    const mappedKey = STYLE_KEY_MAP[key] ?? key;
    out[mappedKey] = value;
  }

  return out;
}
